
export const platformBenefits = {
  title: "Miért válaszd a Bespire-t?",
  subtitle: "Minden eszközt megkapsz, amire egy creatornak szüksége van egy sikeres online vállalkozás felépítéséhez – már csak a megfelelő social jelenlétre van szükséged.",
  benefits: [
    {
      title: "Időmegtakarítás",
      description: "Az AI asszisztensünk segítségével percek alatt létrehozhatod professzionális oldaladat, programozási ismeretek nélkül",
      checks: [
        "Gyors beállítás és okos tartalmi javaslatok", 
        "Automatizált feladatok és adminisztráció"
      ]
    },
    {
      title: "Közösségépítés",
      description: "Építs mélyebb kapcsolatot rajongóiddal a személyes interakciók és exkluzív tartalmak segítségével",
      checks: [
        "Fizetős üzenetváltások és konzultációk", 
        "Személyre szabott videóüzenetek"
      ]
    },
    {
      title: "Biztonság és adatvédelem",
      description: "Platformunk biztonságos környezetet biztosít minden creator és rajongó számára",
      checks: [
        "Biztonságos fizetési rendszer", 
        "GDPR-kompatibilis adatkezelés"
      ]
    },
    {
      title: "Növekedés és bővülés",
      description: "Eszközeink és elemzéseink segítenek vállalkozásod folyamatos fejlődésében és új lehetőségek felfedezésében",
      checks: [
        "Részletes közönség-elemzés", 
        "Személyre szabott növekedési tippek"
      ]
    }
  ],
  learnMore: "Tudj meg többet",
  stats: [
    { value: "300+", label: "Elégedett creator" },
    { value: "98%", label: "Ügyfél elégedettség" },
    { value: "10x", label: "Gyorsabb indulás" },
    { value: "24/7", label: "Támogatás" }
  ]
};
